/**
 * The catalog's results wrapper. Shared by the loaded rows and the loading
 * skeleton so the two are pixel-interchangeable (CT-5185).
 */
export const WIDGET_LIBRARY_LAYOUT_CLASS = 'flex min-w-0 flex-col gap-3';
